import React from "react";

const ComparativaReformas = ({ reformas, indicadores }) => {
    if (!reformas || reformas.length === 0) {
        return <p className="text-center text-gray-500">No hay datos de reformas disponibles.</p>;
    }

    const obtenerIndicador = (reformaId) => {
        return indicadores?.find(i => Number(i.reformaPropiedadId) === Number(reformaId));
    };

    const reformasEstandar = reformas.filter(r => r.tipo_reforma === "Reforma Estándar");
    const reformasPremium = reformas.filter(r => r.tipo_reforma === "Reforma Premium");

    const generarTablaComparativa = (titulo, reformasFiltradas) => {
        if (reformasFiltradas.length === 0) return null;

        const actuacionesUnicas = [...new Set(reformasFiltradas.flatMap(r => r.actuaciones.map(a => a.actuacion)))];
        const minCost = Math.min(...reformasFiltradas.map(r => parseFloat(r.coste_total_reforma))).toFixed(2);
        const maxCost = Math.max(...reformasFiltradas.map(r => parseFloat(r.coste_total_reforma))).toFixed(2);

        return (
            <div className="mt-6 bg-white p-4 rounded-lg shadow-md">
                <h2 className="text-2xl font-semibold mb-4">{titulo}</h2>
                <table className="w-full border-collapse border border-gray-300">
                    <thead>
                    <tr className="bg-gray-200">
                        <th className="border border-gray-300 p-2">Actuación</th>
                        <th className="border border-gray-300 p-2">Cantidad</th>
                        <th className="border border-gray-300 p-2">Unidad</th>
                        {reformasFiltradas.map(reforma => (
                            <th key={reforma.reforma_id} className="border border-gray-300 p-2">
                                {reforma.constructor}
                            </th>
                        ))}
                    </tr>
                    </thead>
                    <tbody>
                    {actuacionesUnicas.map((actuacion, index) => (
                        <tr key={index} className="text-center">
                            <td className="border border-gray-300 p-2">{actuacion}</td>
                            <td className="border border-gray-300 p-2">
                                {reformasFiltradas.find(r => r.actuaciones.some(a => a.actuacion === actuacion))?.actuaciones.find(a => a.actuacion === actuacion)?.cantidad || "-"}
                            </td>
                            <td className="border border-gray-300 p-2">
                                {reformasFiltradas.find(r => r.actuaciones.some(a => a.actuacion === actuacion))?.actuaciones.find(a => a.actuacion === actuacion)?.unidad || "-"}
                            </td>
                            {reformasFiltradas.map(reforma => {
                                const act = reforma.actuaciones.find(a => a.actuacion === actuacion);
                                const total = act ? (parseFloat(act.coste_material_total) + parseFloat(act.coste_mano_obra_total)).toFixed(2) : "-";
                                const bgClass =
                                    total === minCost ? "bg-green-200" :
                                        total === maxCost ? "bg-red-200" : "";
                                return (
                                    <td key={reforma.reforma_id} className={`border border-gray-300 p-2 ${bgClass}`}>
                                        {total} €
                                    </td>
                                );
                            })}
                        </tr>
                    ))}
                    </tbody>
                    <tfoot>
                    <tr className="bg-gray-100 font-bold">
                        <td colSpan="3" className="border border-gray-300 p-2 text-right">Total Reforma:</td>
                        {reformasFiltradas.map(reforma => {
                            const total = parseFloat(reforma.coste_total_reforma).toFixed(2);
                            const bgClass =
                                total === minCost ? "bg-green-300" :
                                    total === maxCost ? "bg-red-300" : "";
                            return (
                                <td key={reforma.reforma_id} className={`border border-gray-300 p-2 ${bgClass}`}>
                                    {total} €
                                </td>
                            );
                        })}
                    </tr>
                    <tr className="bg-gray-50">
                        <td colSpan="3" className="border border-gray-300 p-2 text-right">ROI venta:</td>
                        {reformasFiltradas.map(reforma => {
                            const indicador = obtenerIndicador(reforma.reforma_id);
                            const valor = parseFloat(indicador?.roiVenta);
                            return (
                                <td key={reforma.reforma_id} className="border border-gray-300 p-2">
                                    {isNaN(valor) ? "-" : `${valor.toFixed(2)} %`}
                                </td>
                            );
                        })}
                    </tr>
                    <tr className="bg-gray-50">
                        <td colSpan="3" className="border border-gray-300 p-2 text-right">Alquiler anual:</td>
                        {reformasFiltradas.map(reforma => {
                            const indicador = obtenerIndicador(reforma.reforma_id);
                            const valor = parseFloat(indicador?.rentabilidadAlquilerAnual);
                            return (
                                <td key={reforma.reforma_id} className="border border-gray-300 p-2">
                                    {isNaN(valor) ? "-" : `${valor.toFixed(2)} %`}
                                </td>
                            );
                        })}
                    </tr>
                    </tfoot>
                </table>
            </div>
        );
    };

    return (
        <div>
            {generarTablaComparativa("Comparativa de Reforma Estándar", reformasEstandar)}
            {generarTablaComparativa("Comparativa de Reforma Premium", reformasPremium)}
        </div>
    );
};

export default ComparativaReformas;
